export default "__VITE_ASSET__DJsu$kWD__"